module.exports = __webpack_public_path__ + "img/Xiaoxiao Wu.0ccd884a.jpg";